import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';

import Home from '../pages/public/Home';
import AboutUs from '../pages/public/AboutUs';
import EvidenceResults from '../pages/public/EvidenceResults';
import NewsEvents from '../pages/public/NewsEvents';
import Login from '../pages/public/Login';
import Register from '../pages/public/Register';
import Remember from '../pages/public/Remember';

import ControlQuestions from '../pages/private/ControlQuestions';
import ControlStudents from '../pages/private/ControlStudent';
import ManageUsers from '../pages/private/ManageUsers';
import Profile from '../pages/private/Profile';
import Test from '../pages/private/Test';
import Course from '../pages/private/Course';
import AvailableCourses from '../pages/private/AvailableCourses';
import StudentCourseStudy from '../pages/private/StudentCourseStudy';
import StudentCourseCertificate from '../pages/private/StudentCourseCertificate';
import Evidencias from '../pages/private/Evidencias';
import EvidenciaFormPage from '../pages/private/EvidenciaFormPage';
import NoticiasEventos from '../pages/private/NoticiasEventos';
import NoticiasEventosFormPage from '../pages/private/NoticiasEventosFormPage';

import PrivateRoute from './PrivateRoute';

const AppRouter = () => {
  return (
    <Router>
      <Routes>
        {/* Rutas Públicas */}
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
		<Route path="/Home" element={<MainLayout><Home /></MainLayout>} />
		<Route path="/AboutUs" element={<MainLayout><AboutUs /></MainLayout>} />
		<Route path="/EvidenceResults" element={<MainLayout><EvidenceResults /></MainLayout>} />
		<Route path="/NewsEvents" element={<MainLayout><NewsEvents /></MainLayout>} />
        <Route path="/login" element={<Login />} />
		<Route path="/Register" element={<Register />} />
		<Route path="/Remember" element={<Remember />} />

        {/* Rutas Privadas */}
		<Route path="/ControlQuestions" element={<PrivateRoute><ControlQuestions/></PrivateRoute>}/>
		<Route path="/ControlStudents" element={<PrivateRoute><ControlStudents/></PrivateRoute>}/>
		<Route path="/ManageUsers" element={<PrivateRoute><ManageUsers/></PrivateRoute>}/>
		<Route path="/Profile" element={<PrivateRoute><Profile/></PrivateRoute>}/>
        <Route path="/Test" element={<PrivateRoute><Test/></PrivateRoute>}/>
		<Route path="/Course" element={<PrivateRoute><Course/></PrivateRoute>}/>
		<Route path="/AvailableCourses" element={<PrivateRoute><AvailableCourses/></PrivateRoute>}/>
		<Route path="/curso/:idCurso" element={<PrivateRoute><StudentCourseStudy/></PrivateRoute>}/>
		<Route path="/curso/:idCurso/certificado" element={<PrivateRoute><StudentCourseCertificate/></PrivateRoute>}/>
		<Route path="/Evidencias" element={<PrivateRoute><Evidencias/></PrivateRoute>}/>
		<Route path="/Evidencias/nueva" element={<PrivateRoute><EvidenciaFormPage/></PrivateRoute>}/>
		<Route path="/Evidencias/editar/:id" element={<PrivateRoute><EvidenciaFormPage/></PrivateRoute>}/>
		<Route path="/NoticiasEventos" element={<PrivateRoute><NoticiasEventos/></PrivateRoute>}/>
		<Route path="/NoticiasEventos/nueva" element={<PrivateRoute><NoticiasEventosFormPage/></PrivateRoute>}/>
		<Route path="/NoticiasEventos/editar/:id" element={<PrivateRoute><NoticiasEventosFormPage/></PrivateRoute>}/>
		<Route path="/AddEvidence" element={<Navigate to="/Evidencias" replace />}/>
      </Routes>
    </Router>
  );
};

export default AppRouter;